/** All routes configurations */
export default [
  {
    path: '/',
    name: 'LoginRegister',
    component: () => import(/* webpackChunkName: "login-register" */ '@/views/LoginRegister'),
    meta: { authorizationType: 'login' },
  },
  // routes that requires authenticate
  {
    path: '/platform',
    component: () => import(/* webpackChunkName: "platform" */ '@/views/Platform'),
    meta: { requiresAuthentication: true },
    children: [
      {
        path: '/connections',
        name: 'PlatformConnections',
        component: () => import(/* webpackChunkName: "platform-connections" */ '@/views/PlatformConnections'),
        meta: {
          authorizationType: 'afterLogin',
          permissionAccessType: 'connection_list_display',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/dashboard',
        name: 'PlatformDashboard',
        component: () => import(/* webpackChunkName: "platform-dashboard" */ '@/views/PlatformDashboard'),
        meta: {
          permissionAccessType: 'dashboard_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/callback',
        name: 'PlatformCallback',
        component: () => import(/* webpackChunkName: "platform-callback" */ '@/views/PlatformCallback'),
        meta: {
          permissionAccessType: 'callback_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/callplanner',
        name: 'PlatformCallPlanner',
        component: () => import(/* webpackChunkName: "platform-callplanner" */ '@/views/PlatformCallPlanner'),
        meta: {
          permissionAccessType: 'callplanner_menu_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/projects',
        name: 'PlatformProjects',
        component: () => import(/* webpackChunkName: "platform-projects" */ '@/views/PlatformProjects'),
        meta: {
          permissionAccessType: 'projects_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/project-details/:projectUuid',
        name: 'PlatformProjectDetails',
        component: () => import('@/views/PlatformProjectDetails'),
        props: true,
        meta: {
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/surveys',
        name: 'PlatformSurveys',
        component: () => import(/* webpackChunkName: "platform-campaigns" */ '@/views/PlatformSurveys'),
        meta: {
          permissionAccessType: 'surveys_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/campaigns',
        name: 'PlatformCampaigns',
        component: () => import(/* webpackChunkName: "platform-campaigns" */ '@/views/PlatformCampaigns'),
        meta: {
          permissionAccessType: 'campaigns_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/campaign-details/:campaignUuid',
        name: 'PlatformCampaign',
        component: () => import('@/views/PlatformCampaign'),
        props: true,
        meta: {
          permissionAccessType: 'campaigns_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/reports',
        name: 'PlatformReports',
        component: () => import(/* webpackChunkName: "platform-reports" */ '@/views/PlatformReports'),
        meta: {
          permissionAccessType: 'reports_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/chat',
        name: 'PlatformChat',
        component: () => import(/* webpackChunkName: "platform-chat" */ '@/views/PlatformChat'),
        meta: {
          permissionAccessType: 'can_handle_chat',
          requiresAuthorizationSocket: true,
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/user-details/:userUuid',
        name: 'PlatformUserDetails',
        component: () => import(/* webpackChunkName: "platform-user-detials" */ '@/views/PlatformUserDetails'),
        props: true,
        meta: {
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/blacklist',
        name: 'PlatformBlacklist',
        component: () => import(/* webpackChunkName: "platform-blacklist" */ '@/views/PlatformBlacklist'),
        meta: {
          permissionAccessType: 'blacklist_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/addressbook',
        name: 'PlatformAddressBook',
        component: () => import(/* webpackChunkName: "platform-blacklist" */ '@/views/PlatformAddressBook'),
        meta: {
          permissionAccessType: 'address_book_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/sms',
        name: 'PlatformSms',
        component: () => import(/* webpackChunkName: "platform-sms" */ '@/views/PlatformSms'),
        meta: {
          permissionAccessType: 'sms_access',
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/help',
        name: 'PlatformHelp',
        component: () => import(/* webpackChunkName: "platform-help" */ '@/views/PlatformHelp'),
        meta: {
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/promotions',
        name: 'PlatformPromotions',
        component: () => import(/* webpackChunkName: "platform-faq" */ '@/views/PlatformPromotions'),
        meta: {
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/faq',
        name: 'PlatformFaq',
        component: () => import(/* webpackChunkName: "platform-faq" */ '@/views/PlatformFaq'),
        meta: {
          requiresUnlessOneActiveProject: true,
        },
      },
      {
        path: '/403',
        name: 'Platform403Error',
        component: () => import(/* webpackChunkName: "platform-user-detials" */ '@/views/Platform403Error'),
      },
    ],
  },
  {
    path: '/204',
    name: '204Error',
    component: () => import(/* webpackChunkName: "platform-user-detials" */ '@/views/NoContent204Error'),
  },

  // catch all redirect
  { path: '*', redirect: '/' },
];
